import { useSelector } from "react-redux";
import { combineReducers } from "redux";

import {
  basicPolicyDetailsSlice,
  dynamicQuestionsSlice,
  homeAddressSlice,
  personalDetailsSlice,
  policyCustomizationOptionsSlice,
  policySlice,
  unitsConstructionAndDetailsSlice,
} from "./slices";

export const newPolicyReducers = combineReducers({
  basicPolicyDetails: basicPolicyDetailsSlice.reducer,
  dynamicQuestions: dynamicQuestionsSlice.reducer,
  homeAddress: homeAddressSlice.reducer,
  personalDetails: personalDetailsSlice.reducer,
  policy: policySlice.reducer,
  policyCustomizationOptions: policyCustomizationOptionsSlice.reducer,
  unitsConstructionAndDetails: unitsConstructionAndDetailsSlice.reducer,
});

type NewPolicyState = ReturnType<typeof newPolicyReducers>;

interface NewBusinessRootState {
  newPolicy: NewPolicyState;
}

export const useNewBusinessSelector = <T>(
  selector: (state: NewPolicyState) => T
) => useSelector((state: NewBusinessRootState) => selector(state.newPolicy));

export * from "./slices";
export * from "./utils";
